import { BookmarkAction, BookmarkState } from "./types";
import {sortBookmarks} from "../../utils";
import {API_AUTH_RESET} from "../../constants/API";


const initialState = {
    bookmarksData: [],
    bookmarks: {},
    expanded: null,
    selected: [],
    resorted: false,
    sorting: {
        type: 'default',
        direction: 1
    }
};

const reducer = (state: BookmarkState = initialState, action: BookmarkAction) => {

    
    switch(action.type) {

        case('setBookmarks'): {
            const bkmData = action.bookmarksData;
            const { direction, type } = state.sorting;
            sortBookmarks(bkmData, direction, type);

            return {
                ...state,
                bookmarksData: [...bkmData],
            };
        }

        case('setBkmSortingType'): {
            const bkmData = state.bookmarksData;
            const { direction, type } = action.sorting;
            sortBookmarks(bkmData, direction, type);
            return {
                ...state,
                bookmarksData: [...bkmData],
                sorting: action.sorting
            };
        };

        case('initBookmarkForPane'): {
            const {pane, url, camName, camID, timeBounds} = action;
            return {
                ...state,
                bookmarks: {
                    ...state.bookmarks,
                    [pane]: {
                        camName: camName,
                        id: camID,
                        url: url,
                        pane: pane,
                        inited: true,
                        src: '',
                        fetch: false,
                        success: false,
                        error: false,
                        timeBounds: timeBounds
                    }
                }
            };
        }

        case('errorBookmarkForPane'): return {
            ...state,
            bookmarks: {
                ...state.bookmarks,
                [action.pane]: {
                    ...state.bookmarks[action.pane],
                    camName: action.camName ? action.camName : state.bookmarks[action.pane].camName,
                    error: true,
                    inited: false,
                    fetch: false,
                    success: false
                }
            }
        };

        case('fetchBookmarkForPane'): return {
            ...state,
            bookmarks: {
                ...state.bookmarks,
                [action.pane]: {
                    ...state.bookmarks[action.pane],
                    error: false,
                    inited: false,
                    fetch: true,
                    success: false
                }
            }
        };
        case('successBookmarkForPane'): return {
            ...state,
            bookmarks: {
                ...state.bookmarks,
                [action.pane]: {
                    ...state.bookmarks[action.pane],
                    error: false,
                    inited: false,
                    fetch: false,
                    success: true
                }
            }
        };

        case('setSourceForBookmarkPane'): return {
            ...state,
            bookmarks: {
                ...state.bookmarks,
                [action.pane]: {
                    ...state.bookmarks[action.pane],
                    src: action.src
                }
            }
        };


        case('addTimeStripsBkm'): return {
            ...state,
            bookmarks: {
                ...state.bookmarks,
                [action.pane]: {
                    ...state.bookmarks[action.pane],
                    timestrips: action.strips,
                    continuation_id: action.continuation_id
                }
            }
        };

        case ('expandBookmarkPane'): return {
            ...state,
            expanded: action.expanded
        };

        case('setSelectedItems') : return {
            ...state,
            selected: action.items
        };

        case('@@router/LOCATION_CHANGE'): return {
            ...state,
            bookmarks: {}
        };

        case API_AUTH_RESET : return {
            ...initialState
        };

        default: return {...state}
    }
};

export default reducer